// Single-tenant household app: the admin role belongs to one specific
// account. Compared case-insensitively against the signed-in user's email.
export const ADMIN_EMAIL = 'dakotaberg@gmail.com';

export function isAdmin(email: string | null | undefined): boolean {
  return (email ?? '').toLowerCase() === ADMIN_EMAIL.toLowerCase();
}
